import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { Button } from '../ui/Button';
import { Shield, Zap, TrendingUp, Users, Play, ChevronRight } from 'lucide-react';

export default function Hero() {
  const { isDark } = useTheme();

  return (
    <section className="relative overflow-hidden py-20 lg:py-32">
      {/* Éléments de background décoratifs */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-primary-500/10 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-purple-500/10 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left column - Text content */}
          <div className="text-center lg:text-left">
            {/* Badge de positionnement */}
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500/10 border border-primary-500/20 mb-8">
              <Zap className="w-4 h-4 text-primary-600" />
              <span className="text-sm font-medium text-primary-600 dark:text-primary-400">
                Pour les équipes performance
              </span>
            </div>

            {/* Headline principale */}
            <h1 className={`text-4xl lg:text-5xl xl:text-6xl font-bold leading-tight mb-6 ${
              isDark ? 'text-white' : 'text-gray-900'
            }`}>
              Supervisez votre équipe en{' '}
              <span className="bg-gradient-to-r from-primary-600 to-purple-600 bg-clip-text text-transparent">
                temps réel
              </span>
            </h1>

            {/* Sous-titre orienté résultats */}
            <p className={`text-lg lg:text-xl mb-8 max-w-2xl mx-auto lg:mx-0 ${
              isDark ? 'text-gray-300' : 'text-gray-600'
            }`}>
              +35% de productivité · Visibilité totale · Commissions automatisées
            </p>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-12">
              <Button size="lg" className="group">
                Demander une démo
                <ChevronRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
              <Button variant="outline" size="lg">
                <Play className="w-4 h-4 mr-2" />
                Voir la plateforme
              </Button>
            </div>

            {/* Trust badges */}
            <div className="flex flex-wrap gap-6 justify-center lg:justify-start">
              <div className="flex items-center gap-2">
                <Shield className="w-5 h-5 text-emerald-500" />
                <span className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                  Sécurité niveau banque
                </span>
              </div>
              <div className="flex items-center gap-2">
                <Zap className="w-5 h-5 text-emerald-500" />
                <span className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                  Temps réel
                </span>
              </div>
              <div className="flex items-center gap-2">
                <TrendingUp className="w-5 h-5 text-emerald-500" />
                <span className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                  +35% de performance
                </span>
              </div>
              <div className="flex items-center gap-2">
                <Users className="w-5 h-5 text-emerald-500" />
                <span className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                  500+ équipes
                </span>
              </div>
            </div>
          </div>

          {/* Right column - Mockup */}
          <div className="relative">
            <div className={`absolute inset-0 bg-gradient-to-r from-primary-500 to-purple-600 rounded-3xl blur-3xl opacity-20`}></div>
            <div className={`relative rounded-2xl overflow-hidden shadow-2xl border ${
              isDark ? 'border-gray-800' : 'border-gray-200'
            }`}>
              <img 
                src="/images/dashboard-mockup.png" 
                alt="Dashboard Insight360"
                className="w-full h-auto"
                onError={(e) => {
                  e.target.src = 'https://placehold.co/1200x800/1f2937/ffffff?text=Dashboard+CRM';
                }}
              />
              {/* Overlay gradient pour effet premium */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent pointer-events-none"></div>
            </div>
            
            {/* Éléments flottants décoratifs */}
            <div className="absolute -top-4 -right-4 w-20 h-20 bg-primary-500/20 rounded-full blur-2xl"></div>
            <div className="absolute -bottom-4 -left-4 w-20 h-20 bg-purple-500/20 rounded-full blur-2xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
}